import '../css/Header.css';
import 'bootstrap/dist/css/bootstrap.css';
import {useNavigate} from "react-router-dom";
import homeIcon from "../icons/home-pineapplespin.png";

function Header(props) {
    const navigate = useNavigate();

    function goHome() {
        navigate("/");
    }

    const home = (
        <button className={"home-button"} onClick={() => goHome()}><img className={"home-icon"} src={homeIcon} alt={"homeIcon"}/>
        </button>
    )
    return (
        <header>
            <div className={"container-fluid"}>
                <div className={"header row"}>
                    <h1 className={"heading"}>
                        <span className={"hamburger-span"}>{props.hamburger}</span>
                        <span className={"heading-text"}>Nacho Spin</span>
                        <span className={"home-span"}>{home}</span>
                    </h1>
                </div>
            </div>
        </header>
    )
}

export default Header;